import type { FC } from 'react';
import { memo } from 'react';

import { Icon } from '@procurify/ui'
import { isEmpty } from 'lodash'

import { FormattedDate } from '@webapp/core/components/FormattedDate'
import { type CustomFieldValue as CustomFieldValueEntity } from '@webapp/core/entities/internal/CustomField'
import { type CustomFieldValue } from '@webapp/models'
import { CustomFieldTypes } from '@webapp/models/enums'
import { TableCustomFieldStyled } from './styles/TableCustomFieldStyled'

export interface ITableCustomFieldProps {
  customfield: CustomFieldValue | CustomFieldValueEntity
}

const getFieldType = (
  customFieldValue: CustomFieldValue | CustomFieldValueEntity
) => {
  const { field } = customFieldValue

  if ('field_type' in field) {
    return field.field_type
  }
  return field.type
}

/**
 *
 * Displays custom field value by field type
 *
 */
export const TableCustomField: FC<ITableCustomFieldProps> = memo(
  ({ customfield }) => {
    const renderCustomField = ({ type, value }) => {
      if (type !== CustomFieldTypes.CHECKBOX && isEmpty(value)) {
        return <>--</>
      }
      switch (type) {
        case CustomFieldTypes.CHECKBOX:
          return <Icon icon={value === true ? 'checkmark' : 'times'} />
        case CustomFieldTypes.TEXT:
          return <>{value}</>
        case CustomFieldTypes.DROPDOWN:
          return <>{value}</>
        case CustomFieldTypes.DATE:
          return (
            <>
              <FormattedDate date={value.toString()} />
            </>
          )
        default:
          return null
      }
    }

    const fieldType = getFieldType(customfield)
    const isValidFieldType = Object.values(CustomFieldTypes).includes(fieldType)
    return (
      isValidFieldType && (
        <TableCustomFieldStyled>
          {renderCustomField({
            type: fieldType,
            value: customfield.value,
          })}
        </TableCustomFieldStyled>
      )
    )
  }
)

TableCustomField.displayName = 'TableCustomField'
